export const CLUB_SIGNUP_REQUEST = 'CLUB_SIGNUP_REQUEST';

export const CLUB_SIGNUP_SUCCESS = 'CLUB_SIGNUP_SUCCESS';

export const GET_CLUB_SIGNUP_FOR_SHARING_REQUEST =
  'GET_CLUB_SIGNUP_FOR_SHARING_REQUEST';

export const CLUB_SIGNUP_VIRTUAL_SUCCESS = 'CLUB_SIGNUP_VIRTUAL_SUCCESS';

export const EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST =
  'EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST';
export const CLUB_SIGNUP_OBJECT_REQUESTING = 'CLUB_SIGNUP_OBJECT_REQUESTING';

export const UPDATE_CLUB_SIGNUP_REQUEST = 'UPDATE_CLUB_SIGNUP_REQUEST';

export const RESET_CLUB_SIGNUP_ISFETCHING = 'RESET_CLUB_SIGNUP_ISFETCHING';

export const PROCESS_CLUB_SIGN_UP_REQUEST = 'PROCESS_CLUB_SIGN_UP_REQUEST';

export const PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST =
  'PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST';
export const CREATE_CLUB_SIGNUP_REQUEST = 'CREATE_CLUB_SIGNUP_REQUEST';
export const CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST =
  'CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST';

export const MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE =
  'MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE';
export const MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE =
  'MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE';

// PAYMENT REQUEST CONSTANTS
export const CREATE_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST =
  'CREATE_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST';
export const PROCESS_STRIPE_CLUB_SIGNUP_FROM_PAYMENT_REQUEST =
  'PROCESS_STRIPE_CLUB_SIGNUP_FROM_PAYMENT_REQUEST';
export const GET_VIRTUAL_CART_REQUEST = 'GET_VIRTUAL_CART_REQUEST';

// FULLSTEAM DIGITAL WALLET CONSTANTS
export const CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_REQUESTING =
  'CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_REQUESTING';
export const CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_SUCCESS =
  'CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_SUCCESS';
export const RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING =
  'RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING';
export const GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET =
  'GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET';
export const PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUESTING =
  'PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUESTING';
export const PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_SUCCESS =
  'PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_SUCCESS';
export const PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST =
  'PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST';

export const UPDATE_CLUB_SIGNUP_FREQUENCY_REQUEST =
  'UPDATE_CLUB_SIGNUP_FREQUENCY_REQUEST';
export const UPDATE_CLUB_SIGNUP_ITEM_SELECTION_REQUEST =
  'UPDATE_CLUB_SIGNUP_ITEM_SELECTION_REQUEST';

export const UPDATE_DYNAMIC_PRICING_CLUB_SIGNUP_PACKAGE_REQUEST =
  'UPDATE_DYNAMIC_PRICING_CLUB_SIGNUP_PACKAGE_REQUEST';
